var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_137)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2_137)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1.39474,
    y: 63.3481,
    width: 75,
    height: 75,
    rx: 10,
    transform: "rotate(-60 -1.39474 63.3481)",
    fill: "#1AB8DB",
    fillOpacity: 0.43
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2_137)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 46,
    width: 70,
    height: 70,
    rx: 10,
    transform: "rotate(-40 1 46)",
    fill: "#1AB8DB",
    fillOpacity: 0.75
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_2_137)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 30,
    width: 65,
    height: 65,
    rx: 10,
    transform: "rotate(-20 8 30)",
    fill: "#1AB8DB",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2843 41.9479C67.1584 45.8624 67.5111 50.3337 66.2738 54.4936C65.0365 58.6536 62.2976 62.2053 58.5888 64.4594C54.8801 66.7134 50.466 67.5089 46.2037 66.6914C41.9413 65.8739 38.1348 63.5018 35.5232 60.0355C32.9115 56.5692 31.6811 52.2561 32.0707 47.9336C32.4603 43.6111 34.4422 39.5876 37.6316 36.6443C40.821 33.7009 44.9904 32.0476 49.3302 32.0055C53.67 31.9634 57.8707 33.5354 61.1166 36.4164L65.2321 32.3009C65.425 32.1081 65.6866 31.9999 65.9594 32C66.2321 32.0001 66.4936 32.1085 66.6864 32.3013C66.8793 32.4942 66.9876 32.7557 66.9877 33.0284C66.9877 33.3012 66.8795 33.5627 66.6867 33.7557L56.0469 44.3955L56.0467 44.3958L56.0465 44.396L50.2274 50.215C50.0345 50.4077 49.7729 50.516 49.5001 50.5159C49.2274 50.5158 48.9659 50.4074 48.7731 50.2145C48.5802 50.0217 48.4719 49.7601 48.4718 49.4874C48.4718 49.2147 48.58 48.9531 48.7728 48.7602L53.8118 43.7211C52.499 42.7398 50.8906 42.2358 49.2524 42.2924C47.6143 42.349 46.0446 42.9629 44.8026 44.0326C43.5607 45.1022 42.7208 46.5636 42.422 48.1752C42.1231 49.7868 42.3831 51.4522 43.1589 52.896C43.9348 54.3399 45.1801 55.4758 46.6889 56.116C48.1978 56.7562 49.88 56.8624 51.4574 56.4171C53.0348 55.9718 54.4131 55.0015 55.3644 53.6667C56.3157 52.3319 56.7831 50.7125 56.6893 49.0761C56.6815 48.9411 56.7003 48.806 56.7448 48.6783C56.7892 48.5506 56.8584 48.4329 56.9484 48.332C57.0383 48.2311 57.1473 48.1489 57.2691 48.0901C57.3908 48.0313 57.5229 47.9971 57.6579 47.9894C57.7929 47.9818 57.9281 48.0008 58.0557 48.0454C58.1833 48.09 58.3009 48.1593 58.4017 48.2494C58.5025 48.3395 58.5846 48.4486 58.6432 48.5704C58.7019 48.6922 58.7359 48.8244 58.7434 48.9594C58.8648 51.0766 58.2558 53.1713 57.0181 54.8933C55.7805 56.6154 53.9892 57.8604 51.9438 58.4202C49.8984 58.9801 47.7228 58.8209 45.7807 57.9692C43.8386 57.1175 42.2477 55.6249 41.2739 53.741C40.3002 51.8571 40.0027 49.6961 40.4311 47.6191C40.8594 45.5422 41.9878 43.6752 43.6275 42.3304C45.2671 40.9855 47.3188 40.2443 49.4394 40.2305C51.56 40.2168 53.6211 40.9314 55.278 42.2549L59.6572 37.8758C56.7814 35.3682 53.0776 34.0168 49.2628 34.0831C45.4479 34.1495 41.7933 35.6288 39.0066 38.2349C36.2198 40.8409 34.499 44.3883 34.1774 48.1901C33.8558 51.992 34.9562 55.778 37.2657 58.8151C39.5751 61.8522 42.9292 63.9245 46.6787 64.6307C50.4282 65.3369 54.3064 64.6269 57.5625 62.638C60.8185 60.6491 63.2209 57.5229 64.3044 53.8645C65.3879 50.2062 65.0756 46.2759 63.4278 42.8346C63.3696 42.7127 63.336 42.5806 63.3288 42.4457C63.3217 42.3108 63.3412 42.1758 63.3862 42.0484C63.4312 41.921 63.5009 41.8038 63.5912 41.7034C63.6816 41.6029 63.7908 41.5213 63.9127 41.463C64.0346 41.4048 64.1668 41.3712 64.3017 41.364C64.4366 41.3569 64.5716 41.3764 64.6989 41.4214C64.8263 41.4664 64.9436 41.5361 65.044 41.6264C65.1444 41.7168 65.2261 41.826 65.2843 41.9479Z",
    fill: "black",
    fillOpacity: 0.6
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_137"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2_137"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    fill: "white",
    transform: "translate(-1.39474 63.3481) rotate(-60)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2_137"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white",
    transform: "translate(1 46) rotate(-40)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_2_137"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 65,
    fill: "white",
    transform: "translate(8 30) rotate(-20)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6b0507051dc2efbfb61f6419de8c7056.svg";
export { ForwardRef as ReactComponent };